import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iPopupDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Popup/Popup';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';

export const OrderLockPopupBackButtonId = 'OrderLockPopup.BackButton';
const OrderLockPopupBackButtonOptions: iButtonDisplayOptions & {
    id: string;
} = {
    id: OrderLockPopupBackButtonId,
    text: 't~OrderLockPopup:expired.back',
    type: 'success',
    stylingMode: 'text',
};
propsStore.insert(OrderLockPopupBackButtonOptions);

export const OrderLockPopupId = 'OrderLockPopup.Popup';
const OrderLockPopupOptions: iPopupDisplayOptions = {
    id: OrderLockPopupId,
    dragEnabled: false,
    closeOnOutsideClick: false,
    showCloseButton: false,
    height: 'auto',
    width: '429px',
    showTitle: false,
};
propsStore.insert(OrderLockPopupOptions);
